export const GetUsersDataType = 'GetUsersDataType';